import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
@Component({
  selector: "app-property-1-call-state-default",
  templateUrl: "./property-1-call-state-default.component.html",
  styleUrls: ["./property-1-call-state-default.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Property1CallStateDefaultComponent {
  @Input() property1:
    | "Call"
    | "Directions"
    | "Chevron arrow down"
    | "Cross"
    | "Check"
    | "Normal arrow left"
    | "Edit"
    | "Map view"
    | "List view"
    | "Buy Insurance"
    | "Claim"
    | "Support"
    | "Renew"
    | "Cart"
    | "Language"
    | "Search"
    | "Microphone"
    | "Hamburger menu"
    | "Chevron arrow right"
    | "Chevron arrow up"
    | "Chevron arrow left"
    | "Normal arrow right"
    | "Normal arrow up"
    | "Normal arrow down"
    | "Mail"
    | "Company"
    | "Resources"
    | "Other insurance"
    | "Health insurance"
    | "Bike insurance"
    | "Travel insurance"
    | "Car insurance"
    | "Download"
    | "Home"
    | "Share"
    | "Medical"
    | "Diagnostics"
    | "Like"
    | "Heart"
    | "Locate"
    | "Star"
    | "None"
    | "Inpatient"
    | "Medical insurance"
    | "Organ"
    | "Thermometer"
    | "Insurance benefits"
    | "Hospitalization"
    | "Alcohol"
    | "Law"
    | "Danger"
    | "Cosmetics"
    | "Info"
    | "Sad face"
    | "Users"
    | "Clock"
    | "Calendar"
    | "Delete"
    | "Male"
    | "Female"
    | "Alert"
    | "Dots Menu"
    | "Plus"
    | "Play"
    | "Redo"
    | "Recommended"
    | "Baggage"
    | "Passport Cover"
    | "Cancel"
    | "Brobot"
    | "Copy"
    | "All Insurance"
    | "Card"
    | "Wallet"
    | "Check Circled"
    | "Expand"
    | "Send"
    | "Aayush"
    | "Restore_Recycle_Refresh"
    | "Drug"
    | "Stats"
    | "Printer"
    | "Chrome"
    | "CNG"
    | "Diesel"
    | "Petrol"
    | "Minus"
    | "Whatsapp"
    | "Branches"
    | "Partners"
    | "Hospitals"
    | "Agents"
    | "Garages"
    | "Trending"
    | "Eye"
    | "Volume"
    | "Location"
    | "Bookmark"
    | "Facebook"
    | "Instagram"
    | "Twitter"
    | "Linkedin"
    | "Compare"
    | "Personal accident"
    | "Upload"
    | "Shield"
    | "Filter"
    | "Sort"
    | "Bookmarked"
    | "Rupee"
    | "Camera"
    | "Customize"
    | "help"
    | "User"
    | "Notifications"
    | "Chevron Selector"
    | "scan"
    | "Offers"
    | "Tags"
    | "Files Add"
    | "Policies"
    | "Attach"
    | "PDF"
    | "Marine"
    | "SMS"
    | "Cart Added" = "Call";
  @Input() state: "Default" | "Hover" | "Active" | "Disabled" = "Default";
}
